/* Дверь 2 «от человека» — вход/выход/кто-я (спека §2.2, core/internal/door/door.go). */
import { apiFetch } from "./client";
function fromMeResponse(r) {
    return {
        userId: r.user_id,
        email: r.email,
        isOwner: r.is_owner,
        personId: r.person_id,
        locale: r.locale,
        displayName: r.display_name,
        perms: r.perms ?? [],
        mustChangePassword: r.must_change_password,
    };
}
export async function login(email, password) {
    return apiFetch("/api/auth/login", { method: "POST", body: { email, password } });
}
// Окно ограничителя второго фактора — то же loginRateWindow, что и у входа (ratelimit.go).
const TWO_FACTOR_RATE_WINDOW_SEC = 300;
export async function verifyTwoFactor(challengeToken, code, backup) {
    const r = await fetch("/api/auth/verify-two-factor", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ challengeToken, code, backup }),
    });
    const body = await r.json().catch(() => null);
    if (r.ok && body && body.status === "ok")
        return body;
    if (r.status === 429) {
        if (body && body.status === "locked")
            return body;
        return { status: "locked", retryAfterSec: TWO_FACTOR_RATE_WINDOW_SEC };
    }
    return { status: "invalid", code: body?.error?.code };
}
export async function logout() {
    await apiFetch("/api/auth/logout", { method: "POST" });
}
export async function me() {
    const res = await apiFetch("/api/me");
    return fromMeResponse(res);
}
